import React from "react";
import { GoldenWarrantySelectorContainer } from "./style";
import NumberFormat from "components/numberFormat";
const GoldenWarrantySelector = ({ items, onChange, selected }) => {
  return (
    <GoldenWarrantySelectorContainer>
      <h5>انتخاب طرح کارت طلایی</h5>
      {items.map((golden_warranty) => (
        <div
          className={`item ${selected?.id === golden_warranty.id ? "selected" : ""}`}
          key={golden_warranty.id}
          onClick={() => onChange({ golden_warranty: golden_warranty })}
        >
          <div className="title-area">{golden_warranty.description}</div>
          <div className="price">
            {golden_warranty.added_price ? (
              <NumberFormat value={golden_warranty.added_price} />
            ) : (
              ""
            )}
          </div>
        </div>
      ))}
      <div className="notice">
          خدمات کارت طلایی خودرو شامل سرویس دوره‌ای رایگان برای مدت ۲ سال یا ۴۰ هزار کیلومتر (هرکدام زودتر فرا برسد)
      </div>
    </GoldenWarrantySelectorContainer>
  );
};
export default GoldenWarrantySelector;
